
// ─── ID del mercado activo (lo fija el blade inline antes de este script) ────
// No inicializar a null aquí — sobreescribiría el valor del blade

// URL de la primera imagen de un CSV de nombres. Las imágenes webp tienen
// variante _thumb (tarjetas); las legacy jpg/png se sirven tal cual.
import { escapaHtml, escapaJsEnAtributo } from './utils';

function urlImagenProducto(imagenes, tamano) {
    if (!imagenes) return '/images/no_image.jpg';
    var nombre = imagenes.split(',')[0].trim();
    if (tamano === 'thumb' && /\.webp$/i.test(nombre)) {
        nombre = nombre.replace(/\.webp$/i, '_thumb.webp');
    }
    return window.location.origin + '/storage/uploads/' + nombre;
}

window.compartirProducto = function(mercadoId, productoId, nombre) {
   
    const url = window.location.origin + window.location.pathname + '?producto=' + productoId;
    if (navigator.share) {
        document.body.style.overflow = '';
        navigator.share({ title: nombre, url: url })
            .catch(function() {})
            .finally(function() {
                const m = document.getElementById('modalAddCart');
                if (m && m.style.display !== 'none') document.body.style.overflow = 'hidden';
            });
    } else {
        navigator.clipboard.writeText(url).then(function() {
            const notif = document.getElementById('mensaje-modales');
            const txt   = document.getElementById('mensaje-notificacion-modales');
            if (notif && txt) {
                txt.innerHTML = '¡Enlace copiado al portapapeles!';
                notif.style.display = 'block';
                setTimeout(function() { notif.style.display = 'none'; }, 3000);
            }
        }).catch(function() {
            prompt('Copia este enlace:', url);
        });
    }
};

const _shareIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
</svg>`;

function buildCardProducto(producto) {
    const nombre    = producto.name || '';
    const imagen    = urlImagenProducto(producto.imagenes, 'thumb');
    const precio    = Number(producto.precio).toString().replace('.', ',');
    const medida    = producto.precio_medida || '';
    const desc      = producto.descripcion_corta || '';
    const mercadoId = Number(producto.mercado_id);
    const prodId    = Number(producto.id);
    const nombreEsc = escapaJsEnAtributo(nombre);

    return `
        <div class="card-producto-h" data-nombre="${escapaHtml(nombre.toLowerCase())}" onclick="modalProducto(${mercadoId}, ${prodId})">
            <div class="card-producto-h-left">
                <div class="card-producto-h-img-wrap">
                    <img src="${escapaHtml(imagen)}" alt="${escapaHtml(nombre)}" class="card-producto-h-img">
                </div>
            </div>
            <div class="card-producto-h-body">
                <h3 class="card-producto-h-nombre">${escapaHtml(nombre)}</h3>
                <p class="card-producto-h-precio">${escapaHtml(precio)}${escapaHtml(medida)}</p>
                <p class="card-producto-h-desc">${escapaHtml(desc)}</p>
                <div style="display:flex;gap:6px;justify-content:center;margin-top:6px;">
                    <button onclick="event.stopPropagation(); modalProducto(${mercadoId}, ${prodId})" class="card-producto-h-btn">Ver producto</button>
                    <button onclick="event.stopPropagation(); compartirProducto(${mercadoId}, ${prodId}, '${nombreEsc}')"
                        title="Compartir" class="card-producto-h-btn" style="padding:6px 10px;">
                        ${_shareIconSvg}
                    </button>
                </div>
            </div>
        </div>
    `;
}

function renderProductos(data) {
    // Si la vista inline ya definió renderResultados (tiendaview2), delegar a ella
    if (typeof window.renderResultadosTienda === 'function') {
        window.renderResultadosTienda(data);
        return;
    }
    const $container = $('#content-subcategoria-producto').empty();
    if (data && data.length > 0) {
        data.forEach(producto => $container.append(buildCardProducto(producto)));
    } else {
        $container.append('<p class="text-center text-gray-500 py-6">No se encontraron productos</p>');
    }
}

// ─── Búsqueda live con debounce ──────────────────────────────────────────────
let _searchTimeout = null;

window.filtrarProductos = function(query) {
    clearTimeout(_searchTimeout);
    _searchTimeout = setTimeout(function () {
        const mercadoId = window._tiendaActivaMercadoId;
        if (!mercadoId) return;

        $.ajaxSetup({ headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') } });

        $.ajax({
            type: 'GET',
            url: '/buscarProductosTienda',
            data: { mercado_id: mercadoId, q: query.trim() },
            dataType: 'json',
            beforeSend: function() {
                $('#content-subcategoria-producto').html(
                    '<p class="text-center text-gray-400 py-6 text-sm">Buscando...</p>'
                );
            },
            success: function(response) {
                if (response.success) {
                    renderProductos(response.data);
                }
            },
            error: function() {
                $('#content-subcategoria-producto').html(
                    '<p class="text-center text-red-400 py-6 text-sm">Error al buscar productos</p>'
                );
            }
        });
    }, 300);
};

// ─── Carga por subcategoría ───────────────────────────────────────────────────
window.cargarProductosSubCategoria = (subcategoria_id, nombre_subcategoria, mercado_id = null) => {
    // Limpiar el buscador al cambiar de categoría
    const buscador = document.getElementById('buscador-productos');
    if (buscador) buscador.value = '';

    $.ajaxSetup({ headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') } });

    $.ajax({
        type: 'GET',
        url: '/cargarProductosSubCategoria',
        data: { subcategoria_id, mercado_id },
        dataType: 'json',
        success: function(response) {
            renderProductos(response.success ? response.data : []);
        },
        error: function() { alert('Ocurrió un error al cargar los productos.'); }
    });
};

// ─── Carga todos los productos del mercado ────────────────────────────────────
window.cargarProductos = (mercado_id) => {
    const buscador = document.getElementById('buscador-productos');
    if (buscador) buscador.value = '';

    $.ajaxSetup({ headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') } });

    $.ajax({
        type: 'GET',
        url: '/cargarProductosMercado',
        data: { mercado_id },
        dataType: 'json',
        success: function(response) {
            renderProductos(response.success ? response.data : []);
        },
        error: function() { alert('Ocurrió un error al cargar los productos.'); }
    });
};

// ─── Carga productos destacados ───────────────────────────────────────────────
window.cargarProductosDestacados = (mercado_id) => {
    const buscador = document.getElementById('buscador-productos');
    if (buscador) buscador.value = '';

    $.ajaxSetup({ headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') } });

    $.ajax({
        type: 'GET',
        url: '/cargarProductosDestacados',
        data: { mercado_id },
        dataType: 'json',
        success: function(response) {
            renderProductos(response.success ? response.data : []);
        },
        error: function() { alert('Ocurrió un error al cargar los productos.'); }
    });
};

function escapeHtml(text) {
    return $('<div>').text(text).html();
}

// ─── Modal bottom-sheet ───────────────────────────────────────────────────────
window.openSheet = function(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    document.body.style.overflow = 'hidden';
    el.style.display = 'flex';
    requestAnimationFrame(function() {
        requestAnimationFrame(function() { el.classList.add('modal-open'); });
    });
};

window.closeSheet = function(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var panel = el.querySelector('.modal-panel');
    if (panel) panel.style.transform = '';
    el.classList.remove('modal-open');
    setTimeout(function() {
        el.style.display = 'none';
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
    }, 360);
};

// ─── Helpers de modales específicos ──────────────────────────────────────────
window.openPostalCodesModal = function(codes) {
    var p = document.getElementById('postalCodesP');
    if (p) p.innerText = codes;
    window.openSheet('postalCodesModal');
};

window.openDeliveryScheduleModal = function(schedule) {
    var container = document.getElementById('deliveryScheduleContainer');
    if (!container) return;
    container.innerHTML = '';
    var scheduleData = JSON.parse(schedule);
    Object.keys(scheduleData).forEach(function(key) {
        var mainDiv = document.createElement('div');
        var dayP = document.createElement('p');
        dayP.className = 'text-sm font-semibold text-gray-800';
        dayP.innerText = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();
        mainDiv.appendChild(dayP);
        var secDiv = document.createElement('div');
        scheduleData[key].forEach(function(data) {
            var dP = document.createElement('p');
            dP.className = 'text-sm text-gray-500';
            dP.innerText = data.inicio + ' - ' + data.fin;
            secDiv.appendChild(dP);
        });
        mainDiv.appendChild(secDiv);
        container.appendChild(mainDiv);
    });
    window.openSheet('horariosEnvMediosPModal');
};

// ─── Tiendaview2 — inicialización de página ───────────────────────────────────
window.toggleMasInfo = function() {
    var panel = document.getElementById('panel-mas-info');
    var icon  = document.getElementById('btn-mas-info-icon');
    var label = document.getElementById('btn-mas-info-label');
    if (!panel) return;
    var open = panel.classList.toggle('hidden');
    if (icon)  icon.style.transform  = open ? 'rotate(0deg)' : 'rotate(180deg)';
    if (label) label.textContent     = open ? '+ información' : '- información';
};

window.toggleFiltros = function() {
    var panel = document.getElementById('panel-filtros');
    if (!panel) return;
    panel.classList.toggle('hidden');
    panel.classList.toggle('flex');
};

(function() {
    // Guard: solo ejecutar en tiendaview2 (defer garantiza DOM listo)
    if (!window._tiendaActivaMercadoId) return;

    var MERCADO_ID = window._tiendaActivaMercadoId;
    var CSRF = (document.querySelector('meta[name="csrf-token"]') || {}).getAttribute
        ? document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        : '';

    // ── Carousel automático ───────────────────────────────────────────
    var btnCarousel = document.getElementById('data-carousel-next');
    if (btnCarousel) setInterval(function() { btnCarousel.click(); }, 4000);

    // ── Swipe para cerrar modales en móvil ────────────────────────────
    ['modaltip','envioDomModal','envioTransModal','mapsModal','horariosEnvMediosPModal','postalCodesModal'].forEach(function(id) {
        var panel = document.querySelector('#' + id + ' .modal-panel');
        if (!panel) return;
        var startY = 0, dy = 0, active = false;
        panel.addEventListener('touchstart', function(e) {
            startY = e.touches[0].clientY;
            dy = 0; active = true;
            panel.style.transition = 'none';
        }, { passive: true });
        panel.addEventListener('touchmove', function(e) {
            if (!active) return;
            dy = Math.max(0, e.touches[0].clientY - startY);
            panel.style.transform = 'translateY(' + dy + 'px)';
        }, { passive: true });
        panel.addEventListener('touchend', function() {
            active = false;
            panel.style.transition = '';
            if (dy > 100) { window.closeSheet(id); }
            else { panel.style.transform = ''; }
            dy = 0;
        });
    });

    // ── Chips de categoría: highlight activo ──────────────────────────
    document.querySelectorAll('.categoria-chip').forEach(function(btn) {
        btn.addEventListener('click', function() {
            document.querySelectorAll('.categoria-chip').forEach(function(b) {
                b.classList.remove('!bg-coral-600', '!text-white', '!border-coral-600');
            });
            btn.classList.add('!bg-coral-600', '!text-white', '!border-coral-600');
        });
    });

    // ── Tarjeta de producto (tiendaview2) ─────────────────────────────
    function buildCardTienda(p) {
        var nombre = p.name || '';
        var imagen = urlImagenProducto(p.imagenes, 'thumb');
        var precio = parseFloat(p.precio).toString().replace('.', ',');
        var medida = p.precio_medida || '';
        var desc   = p.descripcion_corta || '';
        var mId    = Number(p.mercado_id);
        var pId    = Number(p.id);

        var card = document.createElement('div');
        card.className = 'card-producto-h';
        card.dataset.nombre = nombre.toLowerCase();
        card.setAttribute('onclick', 'modalProducto(' + mId + ',' + pId + ')');
        card.style.cursor = 'pointer';
        card.innerHTML =
            '<div class="card-producto-h-left">' +
                '<div class="card-producto-h-img-wrap">' +
                    '<img src="' + escapaHtml(imagen) + '" alt="' + escapaHtml(nombre) + '" class="card-producto-h-img">' +
                '</div>' +
            '</div>' +
            '<div class="card-producto-h-body">' +
                '<h3 class="card-producto-h-nombre">' + escapaHtml(nombre) + '</h3>' +
                '<p class="card-producto-h-precio">' + escapaHtml(precio) + (medida ? ' ' + escapaHtml(medida) : '') + '</p>' +
                (desc ? '<p class="card-producto-h-desc">' + escapaHtml(desc) + '</p>' : '') +
                '<button onclick="event.stopPropagation();modalProducto(' + mId + ',' + pId + ')" class="card-producto-h-btn" style="margin-top:6px;">Ver producto</button>' +
            '</div>';
        return card;
    }

    // ── Paginación ────────────────────────────────────────────────────
    var PAGE_SIZE = 10;
    var _todosProductos = [];
    var _paginaActual   = 0;

    function actualizarContador(n) {
        var el = document.getElementById('contador-productos');
        if (el) el.textContent = n > 0 ? n + ' producto' + (n !== 1 ? 's' : '') : '';
    }

    function actualizarVerMas() {
        var wrap = document.getElementById('ver-mas-wrap');
        if (!wrap) return;
        var visibles = (_paginaActual + 1) * PAGE_SIZE;
        wrap.classList.toggle('hidden', visibles >= _todosProductos.length);
    }

    function renderResultados(data) {
        _todosProductos = (data && data.length > 0) ? data : [];
        _paginaActual   = 0;
        var container = document.getElementById('content-subcategoria-producto');
        if (!container) return;
        container.innerHTML = '';
        if (_todosProductos.length === 0) {
            container.innerHTML = '<p class="text-center text-gray-500 py-6 text-sm">No se encontraron productos</p>';
            actualizarVerMas();
            return;
        }
        _todosProductos.slice(0, PAGE_SIZE).forEach(function(p) { container.appendChild(buildCardTienda(p)); });
        actualizarContador(_todosProductos.length);
        actualizarVerMas();
    }

    window.verMasProductos = function() {
        _paginaActual++;
        var container = document.getElementById('content-subcategoria-producto');
        if (!container) return;
        var desde = _paginaActual * PAGE_SIZE;
        _todosProductos.slice(desde, desde + PAGE_SIZE).forEach(function(p) { container.appendChild(buildCardTienda(p)); });
        actualizarVerMas();
    };

    window.renderResultadosTienda = renderResultados;

    // ── Búsqueda live ─────────────────────────────────────────────────
    var searchTimer = null;

    function buscar(query) {
        var container = document.getElementById('content-subcategoria-producto');
        if (!container) return;
        container.innerHTML = '<p class="text-center text-gray-400 py-6 text-sm">Buscando...</p>';
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/buscarProductosTienda?mercado_id=' + MERCADO_ID + '&q=' + encodeURIComponent(query.trim()), true);
        xhr.setRequestHeader('X-CSRF-TOKEN', CSRF);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.onload = function() {
            if (xhr.status === 200) {
                try {
                    var resp = JSON.parse(xhr.responseText);
                    if (resp.success) renderResultados(resp.data);
                } catch(e) {
                    container.innerHTML = '<p class="text-center text-red-400 py-6 text-sm">Error al procesar la respuesta</p>';
                }
            } else {
                container.innerHTML = '<p class="text-center text-red-400 py-6 text-sm">Error al buscar productos</p>';
            }
        };
        xhr.onerror = function() {
            container.innerHTML = '<p class="text-center text-red-400 py-6 text-sm">Error de conexión</p>';
        };
        xhr.send();
    }

    var input = document.getElementById('buscador-productos');
    if (!input) return;

    input.addEventListener('input', function() {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(function() { buscar(input.value); }, 300);
    });
    input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { clearTimeout(searchTimer); buscar(input.value); }
    });

    // Carga inicial
    buscar('');
}());
